import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import api from "../../services/api";

export default function ManageSchemes(){

const [schemes,setSchemes] = useState([]);
const [departments,setDepartments] = useState([]);

const [name,setName] = useState("");
const [departmentId,setDepartmentId] = useState("");

const [editId,setEditId] = useState(null);
const [editName,setEditName] = useState("");
const [editDepartment,setEditDepartment] = useState("");


/* Load Data */

const loadData = () => {

api.get("/admin/departments")
.then(res => setDepartments(res.data));

api.get("/admin/schemes")
.then(res => setSchemes(res.data));

};

useEffect(()=>{
loadData();
},[]);


/* Add Scheme */

const addScheme = async () => {

if(!name || !departmentId) return;

await api.post("/admin/schemes",{
name,
department_id:departmentId
});

setName("");
setDepartmentId("");

loadData();

};


/* Delete */

const deleteScheme = async (id) => {

if(!window.confirm("Delete this scheme?")) return;

await api.delete(`/admin/schemes/${id}`);

loadData();

};


/* Edit Start */

const startEdit = (scheme) => {

setEditId(scheme.id);
setEditName(scheme.name);

const dept = departments.find(d => d.name === scheme.department);

setEditDepartment(dept?.id || "");

};


/* Update */

const updateScheme = async () => {

await api.put(`/admin/schemes/${editId}`,{
name:editName,
department_id:editDepartment
});

setEditId(null);
loadData();

};


return(

<div className="min-h-screen bg-gray-50">

<Navbar/>

<div className="max-w-4xl mx-auto p-10">

<h2 className="text-2xl font-bold mb-6">
Manage Schemes
</h2>


{/* Add Scheme */}

<div className="bg-white shadow rounded p-6 mb-8">

<input
placeholder="Scheme name"
value={name}
className="border p-2 mb-3 w-full"
onChange={e=>setName(e.target.value)}
/>

<select
value={departmentId}
className="border p-2 mb-4 w-full"
onChange={e=>setDepartmentId(e.target.value)}
>

<option value="">
Select Department
</option>

{departments.map(d=>(
<option key={d.id} value={d.id}>
{d.name}
</option>
))}

</select>

<button
onClick={addScheme}
className="bg-purple-600 text-white px-4 py-2 rounded"
>
Add Scheme
</button>

</div>


{/* Scheme List */}

<div className="bg-white shadow rounded">

{schemes.map(s=>(
<div
key={s.id}
className="flex justify-between items-center border-b p-4"
>

{editId === s.id ? (

<div className="flex gap-3 flex-1">

<input
value={editName}
className="border p-2 flex-1"
onChange={e=>setEditName(e.target.value)}
/>

<select
value={editDepartment}
className="border p-2"
onChange={e=>setEditDepartment(e.target.value)}
>

{departments.map(d=>(
<option key={d.id} value={d.id}>
{d.name}
</option>
))}

</select>

</div>

) : (

<div>
<span className="font-medium">
{s.name}
</span>

<span className="text-gray-500 ml-3">
({s.department})
</span>
</div>

)}


<div className="flex gap-2">

{editId === s.id ? (

<>
<button
onClick={updateScheme}
className="bg-blue-600 text-white px-3 py-1 rounded"
>
Save
</button>

<button
onClick={()=>setEditId(null)}
className="bg-gray-400 text-white px-3 py-1 rounded"
>
Cancel
</button>
</>

) : (

<>
<button
onClick={()=>startEdit(s)}
className="bg-yellow-500 text-white px-3 py-1 rounded"
>
Edit
</button>

<button
onClick={()=>deleteScheme(s.id)}
className="bg-red-600 text-white px-3 py-1 rounded"
>
Delete
</button>
</>

)}

</div>

</div>
))}

</div>

</div>

</div>

)

}